import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import CreateAccount from './components/auth/CreateAccount';
import Login from './components/auth/Login';
import Projects from './components/projects/Projects';

import ProjectState from './context/projects/projectState';
import TaskState from './context/tasks/taskState';
import AlertState from './context/alerts/alertState';
import AuthState from './context/auth/authState';
import tokenAuth from './config/authToken';
import PrivateRoute from './components/routes/privateRoute';

// Validate if a token exists
const token = localStorage.getItem('token');
if(token){
  tokenAuth(token);
}

function App() {
  return (
    <ProjectState>
     <TaskState>
      <AlertState>
        <AuthState>
          <Router>
            <Switch>
              <Route exact path="/" component={ Login }/>
              <Route exact path="/create-account" component={ CreateAccount }/>
              <PrivateRoute exact path="/projects" component={ Projects }/>
            </Switch>
          </Router>
        </AuthState>
      </AlertState>
     </TaskState>
    </ProjectState>
  );
}

export default App;
